import { Container } from "@mui/system";

import { useEffect, useState } from "react";
// import { CollapseIcon } from "../assets";
import { useTranslation } from "react-i18next";

import arrowIcon from "../assets/previous_icon.png";

export default function Card({
  Element = Container,
  cardRef,
  cardTitle,
  showMore,
  collapsable = true,
  children,
  collapsed = true,
  ...elementProps
}) {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  const { t } = useTranslation("general");

  useEffect(() => {
    if (!collapsable) {
      setIsCollapsed(false);
    }
  }, []);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Element
      ref={cardRef}
      className={`c-card ${isCollapsed ? "c-collapsed" : ""}`}
      {...elementProps}
    >
      <section className={`c-content`}>
        <div className={`c-cardHead`}>
          <h3 className={`c-cardTitle`}>{cardTitle}</h3>
          {collapsable && (
            <button className={`collapseButton`} onClick={toggleCollapse}>
              {isCollapsed ? `${t("show")}` : `${t("hide")}`}
              <img src={arrowIcon} alt="Show / Hide" />
            </button>
          )}
        </div>
        {!isCollapsed && (
          <div className={`c-cardContent`}>
            {children}
            {showMore && (
              <div className={`c-centeredFlexbox`}>
                <button className={`showMoreButton`}>{t("showMore")}</button>
              </div>
            )}
          </div>
        )}
      </section>
    </Element>
  );
}
